// English + Hindi translations for VARDHAN landing page.
// Keys are grouped by section; access via t("nav.ritual") in components.

const en = {
    lang: {
        title: "Choose your language",
        subtitle: "आप कौन-सी भाषा में जारी रखना चाहेंगे?",
        english: "English",
        hindi: "हिन्दी",
        continue: "Continue",
    },
    nav: {
        ritual: "Ritual",
        benefits: "Benefits",
        faq: "FAQ",
        order_cta: "Order — ₹1999",
        order_short: "Order Now",
        menu_ritual: "Ritual",
        menu_benefits: "Benefits",
        menu_faq: "FAQ",
        menu_order: "Order Now",
    },
    hero: {
        eyebrow: "Ayurvedic Wellness Formulation",
        h1a: "A return",
        h1b_pre: "to ",
        h1b_em: "balance.",
        sub: "A quiet ritual of two amber droppers. VARDHAN is a natural Ayurvedic formulation intended to support overall wellness — helping reduce cravings, supporting recovery, and promoting mental clarity.",
        cta_order: "Order — ₹1999",
        cta_ritual: "The Ritual",
        chapter: "— 00 · Origin",
        since: "Since 2024",
        scroll: "Scroll",
        meta_ml: "2 × 50ml",
        meta_herbal: "Herbal Supplement",
        meta_cod: "COD Available",
    },
    marquee: [
        "100% Ayurvedic",
        "Supports Recovery",
        "Natural Detox",
        "Promotes Mental Wellness",
        "Reduce Cravings",
        "Herbal Supplement",
    ],
    ritual: {
        chapter: "— 01 · The Practice",
        title_1: "A slow ritual.",
        title_2_em: "Practised, not performed.",
        body: "Three unhurried steps, twice a day. That is the whole of it.",
        steps: [
            {
                title: "STEP 1",
                body: "Shake well. Dispense 1–2 droppers directly under the tongue, or into a small glass of warm water. Twice daily, before meals.",
            },
            {
                title: "STEP 2",
                body: "Sublingual delivery is gentle and quick — a slow, considered warmth. Sit with it for a moment.",
            },
            {
                title: "STEP 3",
                body: "A daily practice that supports steady energy, calm focus and a natural rhythm of recovery over weeks of continued use.",
            },
        ],
    },
    benefits: {
        chapter: "— 02 · Manifesto",
        title_pre: "What VARDHAN ",
        title_em: "quietly",
        title_post: " supports.",
        body: "We make no medical claims. VARDHAN is intended to support overall wellness — not to treat, cure or prevent any disease. What we offer is a practice.",
        items: [
            {
                n: "I",
                title: "Helps reduce cravings",
                body: "Formulated with adaptogenic herbs traditionally used to support balance and a steadier response to daily impulses.",
            },
            {
                n: "II",
                title: "Recovery support",
                body: "A gentle daily companion intended to support the body's natural rhythm of rest and recovery.",
            },
            {
                n: "III",
                title: "Promotes mental wellness",
                body: "Herbs like Brahmi and Tulsi are used in Ayurveda to support mental composure and clarity.",
            },
            {
                n: "IV",
                title: "Natural Ayurvedic formula",
                body: "A proprietary blend of time-honoured herbs — no artificial fillers, no fragrance, no colour.",
            },
        ],
    },
    faq: {
        chapter: "— 03 · Questions",
        title_pre: "The ",
        title_em: "obvious",
        title_post: " questions.",
        body: "Everything you might wonder about, laid out plainly. If you need something more specific, our WhatsApp is one tap away.",
        items: [
            {
                q: "What is VARDHAN?",
                a: "VARDHAN is an Ayurvedic proprietary formulation in liquid dropper form (2 × 50 ml) intended to support overall wellness — including reducing cravings, supporting recovery, and promoting mental wellness.",
            },
            {
                q: "How do I use it?",
                a: "Shake the bottle well before use. Dispense 1–2 droppers under the tongue or into a glass of warm water, twice daily before meals. Consistency is more important than dosage.",
            },
            {
                q: "Is it safe for daily use?",
                a: "VARDHAN is made from natural herbal ingredients. That said, individual responses vary. If you are pregnant, nursing, on medication or have a medical condition, please consult a qualified healthcare practitioner before use.",
            },
            {
                q: "How soon can I expect results?",
                a: "Ayurveda works gently, over time. Most users observe subtle shifts within 3–4 weeks of consistent daily practice. Individual results may vary.",
            },
            {
                q: "Is Cash on Delivery available?",
                a: "Yes. COD is available across serviceable pincodes in India. You can also choose Prepaid at checkout — both are handled at the same all-inclusive price of ₹1999.",
            },
            {
                q: "What is your shipping timeline?",
                a: "Orders are dispatched within 24–48 hours and typically delivered in 4–7 business days depending on your location. You will receive a tracking link on your phone.",
            },
            {
                q: "What is your return policy?",
                a: "Because VARDHAN is a consumable herbal supplement, we accept returns only if the seal is intact and the bottle is undamaged, within 7 days of delivery. Reach out on WhatsApp and we will guide you through it.",
            },
        ],
    },
    order: {
        chapter: "— 04 · Order",
        title_1: "One pack.",
        title_2_em: "Two bottles.",
        pack_label: "Pack",
        pack_value: "2 × 50 ml",
        price_label: "Price · all inclusive",
        shipping_label: "Shipping",
        shipping_value: "Free · pan-India",
        trust: [
            "100% Ayurvedic",
            "GMP Certified",
            "Vegan",
            "Cruelty-Free",
            "COD Available",
            "Free Shipping",
        ],
        form_eyebrow: "Delivery Details",
        form_title: "Where should we send it?",
        f_name: "Full Name",
        f_name_ph: "e.g. Aarav Sharma",
        f_phone: "Phone",
        f_phone_ph: "+91 98xxxxxxx",
        f_address: "Shipping Address",
        f_address_ph: "Flat / Street / Landmark / City",
        f_pincode: "Pincode",
        f_pincode_ph: "6-digit PIN",
        f_state: "State",
        f_state_ph: "Select your state",
        payment: "Payment Method",
        cod: "Cash on Delivery",
        cod_desc: "Pay when it arrives",
        prepaid: "Prepaid",
        prepaid_desc: "Pay online — coordinated on WhatsApp",
        total: "Total",
        wa_cta: "Order on WhatsApp",
        submit: "Place Order",
        submitting: "Placing…",
        success_chapter: "— Confirmed",
        success_title: "Thank you, {name}.",
        success_body_1: "Your order has been received. Our team will reach out on ",
        success_body_2: " via WhatsApp to confirm and ship within 24–48 hours.",
        success_another: "Place another",
        success_wa: "Message us on WhatsApp",
        wa_prefill:
            "Hi, I'd like to order VARDHAN (2 × 50ml, ₹{price}).\n\nName: {name}\nPhone: {phone}\nAddress: {address}\nPincode: {pincode}\nState: {state}\nPayment: {payment}",
        errors: {
            name: "Please add your name.",
            phone: "Please add a valid phone number.",
            address: "Please add a complete address.",
            pincode: "Please enter a valid 6-digit pincode.",
            state: "Please select your state.",
            server: "Something went wrong. Please try again or WhatsApp us.",
        },
        toast_success: "Order received. We'll reach out on WhatsApp soon.",
    },
    footer: {
        disclaimer_label: "Disclaimer",
        disclaimer:
            "VARDHAN is an Ayurvedic proprietary formulation intended to support overall wellness. It is not intended to diagnose, treat, cure or prevent any disease. Individual results may vary.",
        support: "Support",
        wa: "WhatsApp",
        faq: "FAQ",
        product: "Product",
        p1: "Detox & Recovery Support",
        p2: "2 × 50 ml — Herbal Supplement",
        p3: "Made in India · GMP Certified Facility",
        copyright: "© {year} VARDHAN. All rights reserved.",
        shake: "Shake well before use · Store in a cool, dry place",
    },
    consult: {
        eyebrow: "Free Expert Consultation",
        title: "A quick chat with our Ayurvedic team — on us.",
        body: "Leave your name and number. Our expert will call you back within 24 hours to answer your questions and guide your ritual.",
        name: "Full Name",
        name_ph: "e.g. Aarav Sharma",
        phone: "Phone",
        phone_ph: "+91 98xxxxxxx",
        submit: "Request Callback",
        submitting: "Sending…",
        dismiss: "Maybe later",
        close: "Close",
        success_title: "Thank you, {name}.",
        success_body: "Our expert will call you on {phone} within 24 hours.",
        toast_success: "Callback requested — we'll be in touch soon.",
        errors: {
            name: "Please add your name.",
            phone: "Please add a valid phone number.",
            server: "Could not send. Please try again in a moment.",
        },
    },
    wa_message: "Hi VARDHAN team — I'd like to know more about your product.",
    quick: {
        eyebrow: "Express Order",
        title: "Get your free expert consultation before order is confirmed and delivered to you.",
        body: "The fastest way to order. We'll call you to confirm the shipping address within a few hours.",
        name: "Full Name",
        name_ph: "e.g. Aarav Sharma",
        phone: "Phone",
        phone_ph: "10-digit mobile",
        submit: "Place Order — ₹1999",
        errors: {
            name: "Name must be at least 3 characters.",
            phone: "Enter a valid 10-digit Indian mobile number.",
        },
    },
};

const hi = {
    lang: {
        title: "अपनी भाषा चुनें",
        subtitle: "Which language would you like to continue in?",
        english: "English",
        hindi: "हिन्दी",
        continue: "आगे बढ़ें",
    },
    nav: {
        ritual: "अनुष्ठान",
        benefits: "लाभ",
        faq: "प्रश्न",
        order_cta: "ऑर्डर — ₹1999",
        order_short: "अभी ऑर्डर करें",
        menu_ritual: "अनुष्ठान",
        menu_benefits: "लाभ",
        menu_faq: "प्रश्न",
        menu_order: "अभी ऑर्डर करें",
    },
    hero: {
        eyebrow: "आयुर्वेदिक स्वास्थ्य सूत्र",
        h1a: "संतुलन",
        h1b_pre: "की ओर ",
        h1b_em: "वापसी।",
        sub: "दो एम्बर ड्रॉपर बोतलों का एक शांत अनुष्ठान। VARDHAN एक प्राकृतिक आयुर्वेदिक सूत्र है जो समग्र स्वास्थ्य को सहारा देने के लिए बनाया गया है — तलब कम करने में मदद, रिकवरी को सहारा, और मानसिक स्पष्टता को बढ़ावा।",
        cta_order: "ऑर्डर — ₹1999",
        cta_ritual: "अनुष्ठान देखें",
        chapter: "— 00 · उत्पत्ति",
        since: "2024 से",
        scroll: "स्क्रॉल",
        meta_ml: "2 × 50 मि.ली.",
        meta_herbal: "हर्बल सप्लीमेंट",
        meta_cod: "COD उपलब्ध",
    },
    marquee: [
        "100% आयुर्वेदिक",
        "रिकवरी सहायक",
        "प्राकृतिक डिटॉक्स",
        "मानसिक स्वास्थ्य",
        "तलब कम करें",
        "हर्बल सप्लीमेंट",
    ],
    ritual: {
        chapter: "— 01 · अभ्यास",
        title_1: "एक धीमा अनुष्ठान।",
        title_2_em: "अभ्यास, प्रदर्शन नहीं।",
        body: "दिन में दो बार, तीन इत्मीनान भरे चरण। बस इतना ही।",
        steps: [
            {
                title: "STEP 1",
                body: "बोतल को अच्छे से हिलाएँ। 1–2 ड्रॉपर सीधे जीभ के नीचे लें, या गुनगुने पानी के छोटे गिलास में मिलाएँ। भोजन से पहले, दिन में दो बार।",
            },
            {
                title: "STEP 2",
                body: "जीभ के नीचे लेने से अवशोषण सौम्य और शीघ्र होता है — एक धीमी, विचारशील गर्माहट। एक क्षण उसके साथ रुकें।",
            },
            {
                title: "STEP 3",
                body: "एक दैनिक अभ्यास जो निरंतर उपयोग के हफ़्तों में स्थिर ऊर्जा, शांत ध्यान और रिकवरी की स्वाभाविक लय को सहारा देता है।",
            },
        ],
    },
    benefits: {
        chapter: "— 02 · घोषणापत्र",
        title_pre: "VARDHAN जो ",
        title_em: "चुपचाप",
        title_post: " सहारा देता है।",
        body: "हम कोई चिकित्सकीय दावा नहीं करते। VARDHAN का उद्देश्य समग्र स्वास्थ्य को सहारा देना है — किसी रोग का उपचार, इलाज या रोकथाम नहीं। हम एक अभ्यास प्रस्तुत करते हैं।",
        items: [
            {
                n: "I",
                title: "तलब कम करने में सहायक",
                body: "पारंपरिक रूप से संतुलन और दैनिक आवेगों के प्रति स्थिर प्रतिक्रिया को सहारा देने वाली एडैप्टोजेनिक जड़ी-बूटियों से निर्मित।",
            },
            {
                n: "II",
                title: "रिकवरी सहायक",
                body: "एक कोमल दैनिक साथी जो शरीर की विश्राम और रिकवरी की स्वाभाविक लय को सहारा देने के लिए बनाया गया है।",
            },
            {
                n: "III",
                title: "मानसिक स्वास्थ्य को बढ़ावा",
                body: "ब्राह्मी और तुलसी जैसी जड़ी-बूटियाँ आयुर्वेद में मानसिक शांति और स्पष्टता को सहारा देने के लिए उपयोग होती हैं।",
            },
            {
                n: "IV",
                title: "प्राकृतिक आयुर्वेदिक सूत्र",
                body: "प्रामाणिक जड़ी-बूटियों का एक विशिष्ट मिश्रण — कोई कृत्रिम भरक नहीं, कोई सुगंध नहीं, कोई रंग नहीं।",
            },
        ],
    },
    faq: {
        chapter: "— 03 · प्रश्न",
        title_pre: "स्पष्ट ",
        title_em: "प्रश्न।",
        title_post: "",
        body: "हर वह बात जिसकी आप उम्मीद कर सकते हैं, सरलता से। कुछ और विशिष्ट चाहिए तो हमारा WhatsApp एक टैप दूर है।",
        items: [
            {
                q: "VARDHAN क्या है?",
                a: "VARDHAN एक आयुर्वेदिक स्वामित्व सूत्र है जो द्रव ड्रॉपर रूप (2 × 50 मि.ली.) में उपलब्ध है, जिसका उद्देश्य समग्र स्वास्थ्य को सहारा देना है — जिसमें तलब कम करना, रिकवरी को सहारा और मानसिक स्वास्थ्य को बढ़ावा शामिल है।",
            },
            {
                q: "मैं इसका उपयोग कैसे करूँ?",
                a: "उपयोग से पहले बोतल को अच्छे से हिलाएँ। 1–2 ड्रॉपर जीभ के नीचे या गुनगुने पानी के गिलास में लें, भोजन से पहले दिन में दो बार। मात्रा से अधिक निरंतरता महत्वपूर्ण है।",
            },
            {
                q: "क्या यह दैनिक उपयोग के लिए सुरक्षित है?",
                a: "VARDHAN प्राकृतिक हर्बल सामग्री से बना है। फिर भी, व्यक्तिगत प्रतिक्रियाएँ भिन्न हो सकती हैं। यदि आप गर्भवती हैं, स्तनपान करा रही हैं, दवाइयाँ ले रहे हैं या कोई चिकित्सा स्थिति है, तो उपयोग से पहले किसी योग्य चिकित्सक से परामर्श लें।",
            },
            {
                q: "परिणाम कब तक दिखेंगे?",
                a: "आयुर्वेद धीरे-धीरे, समय के साथ काम करता है। अधिकांश उपयोगकर्ता 3–4 सप्ताह के लगातार दैनिक अभ्यास में सूक्ष्म बदलाव अनुभव करते हैं। व्यक्तिगत परिणाम भिन्न हो सकते हैं।",
            },
            {
                q: "क्या Cash on Delivery उपलब्ध है?",
                a: "हाँ। भारत भर के सेवा योग्य पिनकोड में COD उपलब्ध है। आप चेकआउट पर Prepaid भी चुन सकते हैं — दोनों एक ही सर्व-समावेशी मूल्य ₹1999 पर हैं।",
            },
            {
                q: "शिपिंग में कितना समय लगता है?",
                a: "ऑर्डर 24–48 घंटों में डिस्पैच होते हैं और आपके स्थान के अनुसार सामान्यतः 4–7 कार्य दिवसों में डिलीवर होते हैं। आपको फ़ोन पर ट्रैकिंग लिंक मिलेगा।",
            },
            {
                q: "वापसी नीति क्या है?",
                a: "चूँकि VARDHAN एक उपभोग्य हर्बल सप्लीमेंट है, हम केवल तब वापसी स्वीकार करते हैं जब सील और बोतल अक्षत हों, डिलीवरी के 7 दिनों के भीतर। WhatsApp पर संपर्क करें, हम आपकी मदद करेंगे।",
            },
        ],
    },
    order: {
        chapter: "— 04 · ऑर्डर",
        title_1: "एक पैक।",
        title_2_em: "दो बोतलें।",
        pack_label: "पैक",
        pack_value: "2 × 50 मि.ली.",
        price_label: "मूल्य · सर्व-समावेशी",
        shipping_label: "शिपिंग",
        shipping_value: "मुफ़्त · पूरे भारत",
        trust: [
            "100% आयुर्वेदिक",
            "GMP प्रमाणित",
            "शाकाहारी",
            "क्रूरता-मुक्त",
            "COD उपलब्ध",
            "मुफ़्त शिपिंग",
        ],
        form_eyebrow: "डिलीवरी विवरण",
        form_title: "हम इसे कहाँ भेजें?",
        f_name: "पूरा नाम",
        f_name_ph: "उदा. आरव शर्मा",
        f_phone: "फ़ोन",
        f_phone_ph: "+91 98xxxxxxx",
        f_address: "शिपिंग पता",
        f_address_ph: "फ़्लैट / गली / लैंडमार्क / शहर",
        f_pincode: "पिनकोड",
        f_pincode_ph: "6-अंकों का PIN",
        f_state: "राज्य",
        f_state_ph: "अपना राज्य चुनें",
        payment: "भुगतान विधि",
        cod: "कैश ऑन डिलीवरी",
        cod_desc: "डिलीवरी पर भुगतान",
        prepaid: "Prepaid",
        prepaid_desc: "ऑनलाइन भुगतान — WhatsApp पर समन्वय",
        total: "कुल",
        wa_cta: "WhatsApp पर ऑर्डर करें",
        submit: "ऑर्डर करें",
        submitting: "भेजा जा रहा है…",
        success_chapter: "— पुष्टि",
        success_title: "धन्यवाद, {name}।",
        success_body_1: "आपका ऑर्डर प्राप्त हो गया है। हमारी टीम ",
        success_body_2:
            " पर WhatsApp के माध्यम से 24–48 घंटों में संपर्क करके पुष्टि करेगी और शिप करेगी।",
        success_another: "एक और ऑर्डर करें",
        success_wa: "WhatsApp पर संदेश भेजें",
        wa_prefill:
            "नमस्ते, मैं VARDHAN (2 × 50 मि.ली., ₹{price}) ऑर्डर करना चाहता/चाहती हूँ।\n\nनाम: {name}\nफ़ोन: {phone}\nपता: {address}\nपिनकोड: {pincode}\nराज्य: {state}\nभुगतान: {payment}",
        errors: {
            name: "कृपया अपना नाम भरें।",
            phone: "कृपया सही फ़ोन नंबर भरें।",
            address: "कृपया पूरा पता भरें।",
            pincode: "कृपया सही 6-अंकों का पिनकोड भरें।",
            state: "कृपया अपना राज्य चुनें।",
            server: "कुछ गड़बड़ी हुई। कृपया दोबारा प्रयास करें या WhatsApp पर संपर्क करें।",
        },
        toast_success: "ऑर्डर प्राप्त हुआ। हम शीघ्र ही WhatsApp पर संपर्क करेंगे।",
    },
    footer: {
        disclaimer_label: "अस्वीकरण",
        disclaimer:
            "VARDHAN एक आयुर्वेदिक स्वामित्व सूत्र है जिसका उद्देश्य समग्र स्वास्थ्य को सहारा देना है। यह किसी रोग के निदान, उपचार, इलाज या रोकथाम के लिए नहीं है। व्यक्तिगत परिणाम भिन्न हो सकते हैं।",
        support: "सहायता",
        wa: "WhatsApp",
        faq: "प्रश्न",
        product: "उत्पाद",
        p1: "डिटॉक्स एवं रिकवरी सहायक",
        p2: "2 × 50 मि.ली. — हर्बल सप्लीमेंट",
        p3: "भारत में निर्मित · GMP प्रमाणित सुविधा",
        copyright: "© {year} VARDHAN. सर्वाधिकार सुरक्षित।",
        shake: "उपयोग से पहले हिलाएँ · ठंडी, सूखी जगह पर रखें",
    },
    consult: {
        eyebrow: "मुफ़्त विशेषज्ञ परामर्श",
        title: "हमारी आयुर्वेदिक टीम से एक निःशुल्क बातचीत।",
        body: "अपना नाम और नंबर छोड़ें। हमारे विशेषज्ञ 24 घंटों के भीतर आपको वापस कॉल करेंगे — आपके प्रश्नों का उत्तर देने और आपके अनुष्ठान में मार्गदर्शन के लिए।",
        name: "पूरा नाम",
        name_ph: "उदा. आरव शर्मा",
        phone: "फ़ोन",
        phone_ph: "+91 98xxxxxxx",
        submit: "कॉलबैक का अनुरोध करें",
        submitting: "भेजा जा रहा है…",
        dismiss: "बाद में",
        close: "बंद करें",
        success_title: "धन्यवाद, {name}।",
        success_body: "हमारे विशेषज्ञ 24 घंटों के भीतर {phone} पर कॉल करेंगे।",
        toast_success: "कॉलबैक का अनुरोध प्राप्त हुआ — हम शीघ्र संपर्क करेंगे।",
        errors: {
            name: "कृपया अपना नाम भरें।",
            phone: "कृपया सही फ़ोन नंबर भरें।",
            server: "अनुरोध नहीं भेजा जा सका। कृपया थोड़ी देर में पुनः प्रयास करें।",
        },
    },
    wa_message: "नमस्ते VARDHAN टीम — मुझे आपके उत्पाद के बारे में और जानना है।",
    quick: {
        eyebrow: "एक्सप्रेस ऑर्डर",
        title: "अपना मुफ़्त विशेषज्ञ परामर्श प्राप्त करें — ऑर्डर कन्फ़र्म होने और डिलीवर होने से पहले।",
        body: "ऑर्डर करने का सबसे तेज़ तरीका। हम कुछ ही घंटों में शिपिंग पता कन्फ़र्म करने के लिए कॉल करेंगे।",
        name: "पूरा नाम",
        name_ph: "उदा. आरव शर्मा",
        phone: "फ़ोन",
        phone_ph: "10-अंकों का मोबाइल",
        submit: "ऑर्डर करें — ₹1999",
        errors: {
            name: "नाम कम से कम 3 अक्षर का होना चाहिए।",
            phone: "कृपया सही 10-अंकों का भारतीय मोबाइल नंबर भरें।",
        },
    },
};

export const dictionaries = { en, hi };

export const getByPath = (obj, path) => {
    return path.split(".").reduce((acc, key) => {
        if (acc == null) return undefined;
        return acc[key];
    }, obj);
};

export const format = (template, params = {}) => {
    if (typeof template !== "string") return template;
    return template.replace(/\{(\w+)\}/g, (_, k) =>
        params[k] !== undefined ? String(params[k]) : `{${k}}`,
    );
};
